import React, { SVGProps } from "react";

export default function SupCamera(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16.17 6.68563L15.701 5.41837L15.2321 6.68563L15.1769 6.83496L15.0275 6.89022L13.7603 7.35915L15.0275 7.82807L15.1769 7.88333L15.2321 8.03266L15.701 9.29992L16.17 8.03266L16.2252 7.88333L16.3746 7.82807L17.6418 7.35915L16.3746 6.89022L16.2252 6.83496L16.17 6.68563ZM10 14.5C11.933 14.5 13.5 12.933 13.5 11C13.5 9.067 11.933 7.5 10 7.5C8.067 7.5 6.5 9.067 6.5 11C6.5 12.933 8.067 14.5 10 14.5Z"
        stroke="currentColor"
      />
    </svg>
  );
}
